export * from './vorlage-delete-request.interface';
export * from './vorlage-delete-response.interface';
export * from './vorlage-delete.shapes';
